module.exports = __webpack_public_path__ + "img/emt-logo-small.08538f51.png";